import { createFormStoreEvents } from '../../create-form-store-events';

export const offshoreStockFormEvents = createFormStoreEvents('offshoreStockFormStore');
